setTimeout(() => {
	const description = document.querySelectorAll('.term-description');
	if (window.innerWidth < 500 && description.length > 0) {
		description.forEach((element) => {
			if (element.querySelector('.excerpt') !== null ) {
				const excerpt = element.querySelector('.excerpt p');
				const link = element.querySelector('.excerpt a');
				excerpt.innerText = excerpt.innerText.substring(0, 100).split(' ').slice(0, -1).join(' ') + '...';
				excerpt.appendChild(link);
			}
		});
	}

	jQuery( function($) {
		// WooCommerce Tabs, toggle tabs
		var tabtittel = '.panel h2:first-child';

		function tabToggle() {
			if ( $( 'ul.tabs' ).css( 'display' ) === 'none' ) {

				$( tabtittel ).siblings().hide();
				$( '#review_form_wrapper' ).hide();

				$( tabtittel ).unbind().click(
					function() {
						console.log('klikket');
						$( this ).siblings().toggle();
						$( this ).parent().toggleClass( 'klikket' );
						if( $(this).parent().attr( 'id' ) === 'comments') {
							$( '#review_form_wrapper' ).toggle();
						}
					}
				);

			} else {

				$( tabtittel ).siblings().show();
				$( '#review_form_wrapper' ).show();

			} // endif

		} // tabToggle()


		tabToggle();

		// Lagrer vindusbredde
		var windowWidth = $(window).width();

		$(window).resize(function(){
			// Sjekker om bredden har endret seg
			if ($(window).width() != windowWidth) {

				// Lagrer ny vindusbredde
				windowWidth = $(window).width();

				tabToggle();
			}

		});
	});



	jQuery(document).on('click', '.product-toggle-contact-form', function(e) {
		e.preventDefault();
		jQuery(this).css('display', 'none');
		jQuery('.product-contact-us').css('display', 'block');
	});


	jQuery(document).on('click', '.search-mobile-menu-button', function(e) {
		e.preventDefault();
		jQuery('body').toggleClass('open-mobile-search');

		setTimeout( () => {
			jQuery('.ais-SearchBox-input').focus();
		}, 100 )

		if ( jQuery('body').hasClass('open-menu') ) {
			toggleMenu(true);
		}
	});

	document.addEventListener('click', (event) => {
		if  ( !event.target.closest('.main-menu, .mobile-menu-button') ) {
			if ( jQuery('body').hasClass('open-menu') ) {
				toggleMenu(true);
			}
		}

		if  ( !event.target.closest('.ais-SearchBox, .search-mobile-menu-button, .fa-search, .fa-times') ) {
			let input = document.getElementsByClassName('ais-SearchBox-input').item(0);
			if ( input && !input.value.trim()) {
				if ( jQuery('body').hasClass('open-mobile-search') ) {
					jQuery('body').removeClass('open-mobile-search');
				}
			}
		}

		if  ( event.target.closest('.read-more-link') ) {
			const description = event.target.closest('.term-description');
			if ( typeof description !== 'undefined' ) {
				description.querySelector('.full').classList.remove('hidden');
				description.querySelector('.excerpt').classList.add('hidden');
			}
		}
	});

	// Submit search form on Enter pressed
	document.addEventListener('keydown', (event) => {
		 // .ais-SearchBox-input is created by Algolia plugin
		if  (event.target.matches('.ais-SearchBox-input') && event.code == 'Enter') {
			if (event.target.parentElement.nodeName !== 'FORM'){
				return;
			}

			const search_string = event.target.value.trim();

			if (search_string.length === 0){
				setTimeout(() => {
					event.target.focus();
				}, 250);
				return;
			}

			const form = event.target.parentElement;
			form.setAttribute('action', '/');
			form.setAttribute('method', 'get');

			const input_s = document.createElement("input");
			input_s.setAttribute('type', 'hidden');
			input_s.setAttribute('name', 's');
			input_s.setAttribute('value', search_string);
			form.append(input_s);

			const input_post_type = input_s.cloneNode();
			input_post_type.setAttribute('name', 'post_type');
			input_post_type.setAttribute('value', 'product');
			form.append(input_post_type);

			form.submit();
		}
	});

	const handleSearchStatus = (search_input_field) => {
		if (search_input_field.value.length) {
			document.body.classList.add('search-active');
		} else {
			document.body.classList.remove('search-active');
		}
	};

	const setSearchStatusEvent = (search_input_field) => {
		if ( typeof search_input_field.dataset.searchStatus == 'undefined') {
			search_input_field.dataset.searchStatus = 'inactive';
		}

		if (search_input_field.dataset.searchStatus !== 'activated') {
			search_input_field.addEventListener('keyup', (event) => {
				handleSearchStatus(search_input_field);
			});
			if (search_input_field.parentElement.nodeName !== 'FORM'){
				return;
			}
			search_input_field.parentElement.addEventListener('reset', (event) => {
				handleSearchStatus(search_input_field);
			});
			search_input_field.dataset.searchStatus = 'activated';
		}
	};

	// Submit search form on Enter pressed
	document.addEventListener('keydown', (event) => {
		// .ais-SearchBox-input is created by Algolia plugin
		if  (event.target.matches('.ais-SearchBox-input')) {
			if (event.target.parentElement.nodeName !== 'FORM'){
				return;
			}

			setSearchStatusEvent( event.target );

			if (event.code !== 'Enter') {
				return;
			}

			const search_string = event.target.value.trim();

			if (search_string.length === 0){
				setTimeout(() => {
					event.target.focus();
				}, 250);
				return;
			}

			const form = event.target.parentElement;
			form.setAttribute('action', '/');
			form.setAttribute('method', 'get');

			const input_s = document.createElement("input");
			input_s.setAttribute('type', 'hidden');
			input_s.setAttribute('name', 's');
			input_s.setAttribute('value', search_string);
			form.append(input_s);

			const input_post_type = input_s.cloneNode();
			input_post_type.setAttribute('name', 'post_type');
			input_post_type.setAttribute('value', 'product');
			form.append(input_post_type);

			form.submit();
		}
	});

	jQuery(document).on('click', '.mobile-menu-button', function(e) {
		if ( jQuery('body').hasClass('open-mobile-search') ) {
			jQuery('body').removeClass('open-mobile-search');
			document.querySelector(".header-product-search form").reset();
		}
	});

	var getCustomerType = 'company';

	function handleCustomerTypeView() {
		let storedCustomerType = localStorage.getItem("customerType");
		let selectedCustomerTypeInput = jQuery('input[type=radio][name=customer_type]:checked');

		if(selectedCustomerTypeInput.length || storedCustomerType) {
			let customerType = storedCustomerType ?? selectedCustomerTypeInput.val();

			jQuery("input[type=radio][name=customer_type][value='" + customerType + "']").prop("checked",true);

			if ( customerType === 'company' ) {
				jQuery('.business-only').show();
				jQuery('.payment_method_invoice').show();
				jQuery('body').removeClass('private');
				jQuery('.woocommerce-terms-and-conditions-link').attr('data-lightbox-content', 'business-terms');
				getCustomerType = 'company';
			} else {
				jQuery('.business-only').hide();
				jQuery('.payment_method_invoice').hide();
				jQuery('#payment_method_dibs_easy').prop('checked', true);
				jQuery('body').addClass('private');
				jQuery('.woocommerce-terms-and-conditions-link').attr('data-lightbox-content', 'private-terms');
				getCustomerType = 'private';
			}

			jQuery(document).ajaxComplete( function() {
				if ( jQuery('input#customer_type_private:checked').val() === 'private' ) {
					jQuery('.payment_method_invoice').hide();
					jQuery('#payment_method_dibs_easy').prop('checked', true);
				} else {
					jQuery('.payment_method_invoice').show();
				}
			})
		}
	}


	function setCustomerTypeHandler() {
		jQuery('input[type=radio][name=customer_type]').change(function() {
			let customerType = jQuery(this).val();

			localStorage.setItem("customerType", customerType);

			handleCustomerTypeView();
		});
	}

	jQuery(document).on('ready', function(e) {
		lightboxClose();
		lightboxTrigger();

		jQuery('input[name*=postcode]').blur(function() {
			jQuery('body').trigger('update_checkout');
		});




		jQuery('input[type=radio][name=want_ehf]').change(function() {
			var customerType = jQuery(this).val();
			if ( customerType === 'yes' ) {
				jQuery('.invoice-email').hide();
			} else {
				jQuery('.invoice-email').show();
			}
		});

		setCustomerTypeHandler();
		handleCustomerTypeView();

		jQuery(function() {
			jQuery( 'body' ).on( 'updated_checkout', function() {
				jQuery('input[name="payment_method"]').change(function(){
					var paymentMethod = jQuery(this).val();
					if ( paymentMethod === 'dibs' ) {
						jQuery('#organization_number_field .required').hide();
						jQuery('#want_ehf_field').hide();
						jQuery('#invoice_email_field').hide();
					} else {
						jQuery('#organization_number_field .required').show();
						jQuery('#want_ehf_field').show();
						jQuery('#invoice_email_field').show();
					}
				});

				var customerFields = jQuery('#customer_type_field');
				if(customerFields.length) {
					if (getCustomerType === 'private') {
						jQuery('.woocommerce-terms-and-conditions-link').attr('data-lightbox-content', 'private-terms');
					} else {
						jQuery('.woocommerce-terms-and-conditions-link').attr('data-lightbox-content', 'business-terms');
					}
				}
			});
		});
	});





	function lightboxTrigger() {
		jQuery(document).on('click', '.lightbox-trigger', function(e){
			e.preventDefault();
			var lightBox = jQuery(this).attr('data-lightbox-content');
			jQuery('.lightbox-container.'+lightBox).css('display', 'flex');
		});
	}

	function lightboxClose() {
		jQuery(document).on('click', '.lightbox-closer', function(e){
			e.preventDefault();
			var lightBox = jQuery(this).closest('.lightbox-container');
			lightBox.hide();
		});
	}

	jQuery( function(){
		lightboxClose();
		lightboxTrigger();
	});





	/*
	 * Expanded category dropdown logic with dashicons
	*/
	jQuery(function ($) {
		// Adds dashicons to all categories with subcategories
		$('.widget_product_categories ul.product-categories li.cat-parent').append('<span class="dashicons dashicons-plus"></span>');

		// Swithing dashicons from plus to minus at page load. Based on if category and subcategories are currently open
		$('.widget_product_categories ul.product-categories li.cat-parent.current-cat-parent > span.dashicons').removeClass('dashicons-plus');
		$('.widget_product_categories ul.product-categories li.cat-parent.current-cat-parent > span.dashicons').addClass('dashicons-minus');
		$('.widget_product_categories ul.product-categories li.cat-parent.current-cat > span.dashicons').removeClass('dashicons-plus');
		$('.widget_product_categories ul.product-categories li.cat-parent.current-cat > span.dashicons').addClass('dashicons-minus');

		// Logic for swithing dashicons from plus to minus (or vice versa) at click
		$('li.cat-parent span.dashicons').on('click', function () {
			$(this).siblings('ul.children').slideToggle();

			if ($(this).hasClass('dashicons-plus')) {
				$(this).removeClass('dashicons-plus');
				$(this).addClass('dashicons-minus');
			} else {
				if ($(this).hasClass('dashicons-minus')) {
					$(this).removeClass('dashicons-minus');
					$(this).addClass('dashicons-plus');
				}
			}
		});
	});

	// Hacky solution to scroll woocommerce-errors into view on the checkout-page
	jQuery(document.body).on('checkout_error', function(event) {
		jQuery('html, body').stop();
		jQuery('html, body').animate(
		{
		  scrollTop: jQuery('.woocommerce-checkout')
			.first()
			.offset().top
		},
		500
	  );
	});
}, 0);

